const css = `._card_14cgb_1 {
  height: 100%;
  padding: 0 24px;
}

._drawer_14cgb_6 {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 100;
}
._drawerCardWrapper_14cgb_17 {
  height: 100vh;
  overflow-y: auto;
  position: absolute;
  width: 90%;
  max-width: 576px;
  top: 0;
  width: 80vw;
  max-width: 576px;
  z-index: 200;
}
._drawerCardWrapper_14cgb_17[data-drawer-position=left] {
  animation: _drawerSlideInFromLeft_14cgb_1 0.35s cubic-bezier(1, 0.01, 0.2, 1);
  border-right: 1px solid var(--border-color);
  left: 0;
}
._drawerCardWrapper_14cgb_17[data-drawer-position=right] {
  animation: _drawerSlideInFromRight_14cgb_1 0.35s cubic-bezier(1, 0.01, 0.2, 1);
  border-left: 1px solid var(--border-color);
  right: 0;
}
._drawerCardWrapperFooter_14cgb_38 {
  bottom: 0;
  position: sticky;
}
._drawerOverlay_14cgb_42 {
  background-color: var(--drawer-background-color);
  border: 0 none transparent;
  height: 100vh;
  left: 0;
  position: absolute;
  top: 0;
  width: 100vw;
  z-index: 100;
}

@keyframes _drawerSlideInFromLeft_14cgb_1 {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes _drawerSlideInFromRight_14cgb_1 {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "card": "_card_14cgb_1",
  "drawer": "_drawer_14cgb_6",
  "drawerCardWrapper": "_drawerCardWrapper_14cgb_17",
  "drawerSlideInFromLeft": "_drawerSlideInFromLeft_14cgb_1",
  "drawerSlideInFromRight": "_drawerSlideInFromRight_14cgb_1",
  "drawerCardWrapperFooter": "_drawerCardWrapperFooter_14cgb_38",
  "drawerOverlay": "_drawerOverlay_14cgb_42"
};